import { Box, Button, Grid2, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { featureList } from "../constants/CreateProfileLists";
import fightIconBg from "../assets/images/flight-icon-with-bg.png";
import PlanSelectionModal from "./PlanSelectionModal";
import EditPaymentCard from "../pages/Profile/EditProfile/EditPaymentCard";
import EchoAccessPassModal from "./EchoAccessPassModal";
import YearlyPremiumModal from "./YearlyPremiumModal";
import YearlyEssentialModal from "./YearlyEssentialModal";
import IntroductoryOfferModal from "./IntroductoryOfferModal";
import CancelSubscription from "./CancelSubscriptionModal";
import Loader from "./Loader";
import usePlanCarousel from "../hooks/usePlanCarousel";
import CarouselArrowButtons from "./PlanCarousel/ArrowButtons";
import PlanCardHeader from "./PlanCarousel/PlanCardHeader";
import ApplySubscriptionDiscount from "./ApplySubscriptionDiscount";
import {
  cardWrapperSx,
  cardInnerSx,
  gradientHeaderSx,
  priceBadgeSx,
  activeBadgeSx,
  featureTextSx,
  actionButtonSx,
  featureListContainerSx,
} from "./PlanCarousel/styles";
import "../assets/styles/embla-carousel.css";

const underlineUnlimited = (text) =>
  text.split(/(unlimited)/i).map((part) =>
    /unlimited/i.test(part) ? (
      <span key={part} style={{ textDecoration: "underline" }}>
        {part}
      </span>
    ) : (
      <span key={part}>{part}</span>
    ),
  );

const ChangeSponsorPlan = () => {
  const {
    emblaRef,
    emblaApi,
    activeIndex,
    handlePrev,
    handleNext,
    packInfo,
    loading,
    activePack,
    foundItem,
    handleCancelConfirm,
    showPayScreen,
    setShowPayScreen,
    handleClosePayScreen,
    selected,
    setSelected,
    selectedPlan,
    setSelectedPlan,
    openPlansModal,
    setOpenPlansModal,
  } = usePlanCarousel();

  const role = localStorage.getItem("role");
  const [packToShow, setPackToShow] = useState({});
  const [openIntroductoryOfferModal, setOpenIntroductoryOfferModal] =
    useState(false);
  const [showModals, setShowModals] = useState({
    yearlyEssentialModal: false,
    yearlyPremiumModal: false,
    echoAccessPassModal: false,
    cancelPlan: false,
  });

  const price =
    foundItem?.prices?.[1]?.unit_amount || foundItem?.prices?.[0]?.unit_amount;

  const handleModalOpen = (pack) => {
    setPackToShow(pack);
    if (pack?.name === "One-Year Essentials Plan") {
      setShowModals((prev) => ({ ...prev, yearlyEssentialModal: true }));
    }
    if (pack?.name === "One-Year Premium Plan") {
      setShowModals((prev) => ({ ...prev, yearlyPremiumModal: true }));
    }
    if (pack?.name === "Echo Access Pass") {
      setShowModals((prev) => ({ ...prev, echoAccessPassModal: true }));
    }
  };

  const handleChange = (pack) => {
    if (activePack?.subscriptionPlanId === pack.id) {
      setShowModals((prev) => ({ ...prev, cancelPlan: true }));
    } else {
      if (pack?.name !== "Echo Access Pass") {
        setOpenPlansModal(true);
      } else {
        setShowPayScreen(true);
      }
      setSelected(pack);
    }
  };

  useEffect(() => {
    if (!emblaApi || !packInfo?.length) return;
    if (activePack) {
      const foundIndex = packInfo?.findIndex(
        (item) => item?.productId === activePack?.productId,
      );
      if (foundIndex >= 0) emblaApi.scrollTo(foundIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emblaApi, packInfo?.length, activePack]);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {loading && <Loader />}
      {showPayScreen ? (
        <EditPaymentCard
          selectedPackage={packInfo[activeIndex]}
          selectedPlan={selectedPlan}
          handleClosePayScreen={handleClosePayScreen}
          setSelectedPlan={setSelectedPlan}
        />
      ) : (
        <Grid2 container sx={{ height: "100%" }}>
          <Grid2 size={{ xs: 12 }} sx={{ height: "100%" }}>
            <Grid2 container sx={{ height: "100%" }}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Box
                  className="carousel-container carousel-container--edit"
                  sx={{ height: "100%" }}
                >
                  <CarouselArrowButtons
                    onPrev={handlePrev}
                    onNext={handleNext}
                  />

                  <div
                    className="embla embla--edit embla--sponsor embla--fade embla--opaque-cards"
                    ref={emblaRef}
                  >
                    <div className="embla__container">
                      {packInfo &&
                        packInfo.map((pack, index) => {
                          const currentPackPrice =
                            pack?.prices?.[1]?.unit_amount;
                          return (
                            <div
                              className="embla__slide embla__slide--edit embla__slide--sponsor"
                              key={pack?.id}
                              onClick={() => emblaApi?.scrollTo(index)}
                            >
                              <div
                                className={`embla__slide__inner embla__slide__inner--edit${index === activeIndex ? " active" : ""}${!pack?.introductoryOffer?.isActive ? " hide-limited-card" : ""}`}
                              >
                                <Box sx={cardWrapperSx}>
                                  <Box
                                    sx={{
                                      ...cardInnerSx,
                                      justifyContent: "flex-start",
                                    }}
                                  >
                                    <Box
                                      sx={gradientHeaderSx(
                                        index === activeIndex,
                                      )}
                                    >
                                      <PlanCardHeader
                                        pack={pack}
                                        index={index}
                                        activeIndex={activeIndex}
                                      />

                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          marginBottom: pack?.introductoryOffer
                                            ?.isActive
                                            ? "25px"
                                            : 0,
                                        }}
                                      >
                                        {pack?.name !== "Echo Access Pass" && (
                                          <Box
                                            className="cust-price-container"
                                            sx={{
                                              display: "flex",
                                              gap: "10px",
                                              backgroundColor: "transparent",
                                            }}
                                          >
                                            {activePack?.subscriptionPlanId ===
                                              pack.id && (
                                              <Typography
                                                className="cust-price-active"
                                                sx={{
                                                  ...activeBadgeSx,
                                                  fontSize: "12px",
                                                }}
                                              >
                                                Active
                                              </Typography>
                                            )}
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                ...priceBadgeSx(
                                                  index === activeIndex,
                                                ),
                                                fontSize: "12px",
                                              }}
                                            >
                                              $
                                              {pack?.prices[0]?.unit_amount /
                                                100}{" "}
                                              per month
                                            </Typography>
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                ...priceBadgeSx(
                                                  index === activeIndex,
                                                ),
                                                fontSize: "12px",
                                              }}
                                            >
                                              $
                                              {pack?.prices[1]?.unit_amount /
                                                100}{" "}
                                              per year
                                            </Typography>
                                          </Box>
                                        )}
                                        {pack?.name === "Echo Access Pass" && (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              gap: "10px",
                                            }}
                                          >
                                            {activePack?.subscriptionPlanId ===
                                              pack.id && (
                                              <Typography
                                                sx={{
                                                  ...activeBadgeSx,
                                                  fontSize: "12px",
                                                }}
                                              >
                                                Active
                                              </Typography>
                                            )}
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                ...priceBadgeSx(
                                                  index === activeIndex,
                                                ),
                                                fontSize: "12px",
                                              }}
                                            >
                                              3 Months: $
                                              {pack?.prices[0]?.unit_amount /
                                                100}
                                            </Typography>
                                          </Box>
                                        )}

                                        {index === activeIndex && (
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              padding: "3px 10px",
                                              backgroundColor: "#F1F7FA24",
                                              cursor: "pointer",
                                              color: "#fff",
                                              borderRadius: "20px",
                                              fontWeight: 600,
                                              display: "flex",
                                              alignItems: "center",
                                              border: "1px solid",
                                              borderColor: "#fff",
                                              fontSize: "12px",
                                              fontFamily: "PT Sans, sans-serif",
                                            }}
                                            onClick={() =>
                                              handleModalOpen(pack)
                                            }
                                          >
                                            More details
                                          </Typography>
                                        )}
                                      </Box>
                                      {pack?.introductoryOffer?.isActive && (
                                        <Box
                                          className={`time-offer-card sponsor ${index === activeIndex ? "active" : ""}`}
                                          sx={{
                                            background:
                                              "linear-gradient(to right, #FFF5D6, #FFD75D, #FFF5D6, #FFD75D)",
                                            width: "calc(100% - 30px)",
                                            margin: "0 auto",
                                            borderRadius: "10px",
                                            padding: "13px",
                                            textAlign: "left",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontSize: {
                                                xs: "12px",
                                                sm: "14px",
                                                xl: "16px",
                                              },
                                              fontWeight: 700,
                                              color: "black",
                                            }}
                                          >
                                            Limited Time Offer!
                                          </Typography>
                                          <Typography
                                            variant="p"
                                            sx={{
                                              fontSize: {
                                                xs: "12px",
                                                sm: "13px",
                                                md: "11px",
                                                xl: "14px",
                                              },
                                            }}
                                          >
                                            Get{" "}
                                            {
                                              pack?.introductoryOffer
                                                ?.freeMonths
                                            }{" "}
                                            extra months of Free Content
                                            Retention!
                                          </Typography>
                                        </Box>
                                      )}
                                    </Box>

                                    <Box sx={featureListContainerSx}>
                                      <Box
                                        sx={{
                                          padding: {
                                            xs: "20px",
                                            xl: "20px 30px",
                                          },
                                          flex: 1,
                                          overflowY: "auto",
                                          width: "100%",
                                          marginBottom: "15px",
                                        }}
                                        className="card-inner-height"
                                      >
                                        {featureList[role][
                                          pack?.name?.toLowerCase().trim()
                                        ]?.map((item, idx) => (
                                          <Box
                                            key={item[0]}
                                            sx={{
                                              textAlign: "left",
                                              marginBottom:
                                                idx !== 0 ? "8px" : "24px",
                                              display: "flex",
                                            }}
                                          >
                                            {idx !== 0 && (
                                              <img
                                                src={fightIconBg}
                                                alt=""
                                                style={{
                                                  width: "21px",
                                                  height: "21px",
                                                  marginRight: "8px",
                                                }}
                                              />
                                            )}
                                            <Typography
                                              variant="h4"
                                              sx={{
                                                ...featureTextSx(
                                                  index === activeIndex,
                                                ),
                                                fontWeight:
                                                  idx !== 0 ? "600" : "400",
                                              }}
                                            >
                                              {underlineUnlimited(item[0])}{" "}
                                              <Typography
                                                variant="span"
                                                sx={{ fontWeight: 400 }}
                                              >
                                                {underlineUnlimited(item[1])}
                                              </Typography>
                                            </Typography>
                                          </Box>
                                        ))}
                                      </Box>
                                      {index === activeIndex && (
                                        <>
                                          {activePack?.subscriptionPlanId ===
                                            pack.id && (
                                            <ApplySubscriptionDiscount
                                              activePack={activePack}
                                            />
                                          )}
                                          {(!activePack?.subscriptionPlanId ||
                                            (activePack?.subscriptionPlanId !==
                                              pack.id &&
                                              price < currentPackPrice)) && (
                                            <Button
                                              onClick={() => handleChange(pack)}
                                              variant="contained"
                                              sx={actionButtonSx}
                                            >
                                              Update Plan
                                            </Button>
                                          )}
                                        </>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      )}
      {openPlansModal && (
        <PlanSelectionModal
          openPlansModal={openPlansModal}
          handleCancel={() => {
            setOpenPlansModal(false);
            setSelectedPlan(null);
            setSelected(null);
          }}
          selectedPackage={selected}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          handleConfirm={() => {
            setOpenPlansModal(false);
            setOpenIntroductoryOfferModal(true);
          }}
        />
      )}
      {showModals.yearlyEssentialModal && (
        <YearlyEssentialModal
          open={showModals.yearlyEssentialModal}
          onClose={() =>
            setShowModals({ ...showModals, yearlyEssentialModal: false })
          }
          packToShow={packToShow}
        />
      )}
      {openIntroductoryOfferModal && (
        <IntroductoryOfferModal
          open={openIntroductoryOfferModal}
          pack={selected}
          selectedPlan={selectedPlan}
          onClose={() => {
            setShowPayScreen(true);
            setOpenIntroductoryOfferModal(false);
          }}
          handleBack={() => {
            setOpenIntroductoryOfferModal(false);
            setShowPayScreen(false);
          }}
        />
      )}
      {showModals.yearlyPremiumModal && (
        <YearlyPremiumModal
          open={showModals.yearlyPremiumModal}
          onClose={() =>
            setShowModals({ ...showModals, yearlyPremiumModal: false })
          }
          packToShow={packToShow}
        />
      )}
      {showModals.echoAccessPassModal && (
        <EchoAccessPassModal
          open={showModals.echoAccessPassModal}
          onClose={() =>
            setShowModals({ ...showModals, echoAccessPassModal: false })
          }
          packToShow={packToShow}
        />
      )}
      {showModals?.cancelPlan && (
        <CancelSubscription
          open={showModals?.cancelPlan}
          handleConfirm={() =>
            handleCancelConfirm(() =>
              setShowModals({ ...showModals, cancelPlan: false }),
            )
          }
          loading={loading}
          handleClose={() =>
            setShowModals({ ...showModals, cancelPlan: false })
          }
          userType="corporate"
        />
      )}
    </Box>
  );
};

export default ChangeSponsorPlan;
